import { useTranslation } from 'react-i18next';
import { PagePath, Theme } from '@monorepo/client-types';
import { useThemeContext } from '@monorepo/hub-common';
import { SystemIcon } from '@monorepo/nova-icons';
import { Switch, Typography, useTheme } from '@monorepo/nova-ui';
import { useLocalStorage } from '@monorepo/react-hooks';
import { IsLoggedInKey } from '@monorepo/types';
import { useConditionalLink, useGetLogoutUrl } from '../../../../hooks';
import {
  ProfileMenuOption,
  ProfileMenuOptionValue,
} from './profile-menu.types';

export const useProfileMenuOptions = (
  handleClose: () => void,
): ProfileMenuOption[] => {
  const { palette, spacing } = useTheme();
  const { toggleTheme } = useThemeContext();
  const { storedValue: isUserLoggedIn } = useLocalStorage(IsLoggedInKey, false);
  const hubLogoutUrl = useGetLogoutUrl();
  const { t } = useTranslation('hubCommon');
  const Link = useConditionalLink();

  return [
    {
      value: ProfileMenuOptionValue.Profile,
      hidden: !isUserLoggedIn,
      label: (
        <Link
          to={PagePath.Profile}
          onClick={handleClose}
          style={{ textDecoration: 'none', width: '100%', height: '100%' }}
        >
          <Typography
            variant="body2"
            paddingTop={spacing(0.25)}
            sx={{
              color: {
                xs: palette.text.main,
                sm: palette.text.second,
              },
            }}
          >
            {t('profile')}
          </Typography>
        </Link>
      ),
      icon: <SystemIcon iconName="User" color={palette.text.second} />,
    },
    {
      value: ProfileMenuOptionValue.Theme,
      label: (
        <Typography
          variant="body2"
          paddingTop={spacing(0.25)}
          sx={{
            color: {
              xs: palette.text.main,
              sm: palette.text.second,
            },
          }}
        >
          {palette.mode === Theme.Dark ? t('darkTheme') : t('lightTheme')}
        </Typography>
      ),
      leftComponent: (
        <Switch checked={palette.mode === Theme.Dark} onChange={toggleTheme} />
      ),
      onClick: () => {
        toggleTheme();
        handleClose();
      },
    },
    {
      value: ProfileMenuOptionValue.Logout,
      hidden: !isUserLoggedIn,
      label: (
        <Typography
          variant="body2"
          paddingTop={spacing(0.25)}
          sx={{
            color: {
              xs: palette.text.main,
              sm: palette.text.second,
            },
          }}
        >
          {t('logout')}
        </Typography>
      ),
      icon: (
        <SystemIcon
          iconName="SignOut"
          sx={{ px: 0.25 }}
          color={palette.text.second}
        />
      ),
      onClick: () => {
        window.location.href = hubLogoutUrl;
        handleClose();
      },
    },
  ];
};
